"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var jsx_runtime_1 = require("react/jsx-runtime");

var react_1 = __importDefault(require("react")); // Libs Accordion


var harris_icon_font_1 = __importDefault(require("@rotaryintl/harris-icon-font"));

var hook_use_bem_classes_1 = __importDefault(require("@rotaryintl/hook-use-bem-classes"));

var classnames_1 = __importDefault(require("classnames"));

require("./styles.css");

var Accordion = function (_a) {
  var items = _a.items,
      _b = _a.theme,
      theme = _b === void 0 ? 'light' : _b;
  var bem = (0, hook_use_bem_classes_1.default)('rotaryui-accordion');

  var _c = react_1.default.useState(null),
      active = _c[0],
      setActive = _c[1];

  var handleToggle = function (index) {
    setActive(function (prevIndex) {
      return prevIndex === index ? null : index;
    });
  };

  return (0, jsx_runtime_1.jsx)("div", __assign({
    className: (0, classnames_1.default)({
      light: theme === 'light',
      dark: theme === 'dark'
    })
  }, {
    children: items.map(function (item, index) {
      return (0, jsx_runtime_1.jsxs)("div", __assign({
        className: (0, classnames_1.default)(bem())
      }, {
        children: [(0, jsx_runtime_1.jsx)("header", __assign({
          className: (0, classnames_1.default)(bem('accordion-main-header'))
        }, {
          children: (0, jsx_runtime_1.jsxs)("button", __assign({
            type: "button",
            disabled: item.disabled,
            tabIndex: item.disabled ? -1 : 0,
            className: (0, classnames_1.default)('accordion-toggle', {
              active: active === index,
              disabled: !!item.disabled
            }),
            onClick: function () {
              return handleToggle(index);
            }
          }, {
            children: [(0, jsx_runtime_1.jsxs)("div", __assign({
              className: (0, classnames_1.default)('accordion-title-box')
            }, {
              children: [(0, jsx_runtime_1.jsx)("span", __assign({
                className: (0, classnames_1.default)('accordion-title')
              }, {
                children: item.title
              })), item.subTitle && (0, jsx_runtime_1.jsx)("span", __assign({
                className: (0, classnames_1.default)('accordion-subtitle')
              }, {
                children: item.subTitle
              }))]
            })), (0, jsx_runtime_1.jsx)(harris_icon_font_1.default, {
              className: !item.disabled ? (0, classnames_1.default)('accordion-icon') : (0, classnames_1.default)('accordion-disable-icon'),
              type: "fas-angle-down",
              size: "24"
            })]
          }))
        })), active === index && !item.disabled ? (0, jsx_runtime_1.jsx)("div", __assign({
          className: (0, classnames_1.default)(bem('accordion-content'), bem('accordion-collapse'), {
            show: active === index && !item.disabled
          })
        }, {
          children: (0, jsx_runtime_1.jsx)("div", __assign({
            className: (0, classnames_1.default)(bem('accordion-body'))
          }, {
            children: item.text
          }))
        })) : null, (0, jsx_runtime_1.jsx)("hr", {
          className: (0, classnames_1.default)(bem('accordion-border'))
        })]
      }), "".concat(index, "-").concat(item.title));
    })
  }));
};

exports.default = Accordion;